export default {
  "brand.name": "USFansSheet",
  "nav.home": "Home",
  "nav.categories": "Categories",
  "nav.article": "Guides",
  "nav.faq": "FAQ",
  "nav.shoppingGuide": "Shopping Guide",
  "nav.guides": "Guides",
  "buttons.buyNow": "Buy It Now",
  "buttons.usfansSpreadsheet": "USFans Spreadsheet",
  "buttons.viewAll": "View All Categories",
  "buttons.go": "Go",
  "categories.shoes": "Shoes",
  "categories.hoodies": "Hoodies / Sweaters",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jackets",
  "categories.pants": "Pants / Shorts",
  "categories.headwear": "Headwear",
  "categories.sets": "Sets",
  "categories.underwear": "Underwear / Underpants",
  "categories.jersey": "Jersey",
  "categories.accessories": "Accessories",
  "categories.bags": "Bags",
  "categories.belts": "Belts",
  "categories.perfumes": "Perfumes",
  "categories.other": "Other Stuff",
  "footer.disclaimer": "USFansSheet is an independent informational resource. Information may change over time. Always verify current product, seller, shipping, payment and promotional information independently before making decisions.",
  "footer.rights": "All rights reserved.",
  "footer.explore": "Explore",
  "footer.categories": "Categories",
  "footer.resources": "Resources",
  "pillar.title": "Pillar Guides",
  "pillar.subtitle": "Explore our in-depth guides to USFans research, QC, shipping, safety and more.",
  "pillar.readMore": "Read Guide",
  "published": "Published",
  "updated": "Updated",
  "readingTime": "min read",
  "backHome": "Back to Home",
  "breadcrumbHome": "Home",
  "breadcrumbCurrent": "Guide",
  "notFound.title": "Guide Not Found",
  "notFound.back": "Back to Home",
  "tag.beginner": "Beginner Guide",
  "tag.research": "Research Guide",
  "tag.qc": "QC Guide",
  "tag.shipping": "Shipping Guide",
  "tag.warehouse": "Warehouse Guide",
  "tag.safety": "Safety Guide",
  "tag.categories": "Categories Guide",
  "tag.compare": "Comparison Guide",
  "tag.coupon": "Coupon Guide",
  "tag.seller": "Seller Guide",
};